document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-open-membership-comparison]');
  if (!trigger) return;
  e.preventDefault();
  var dialog = document.getElementById('membership-comparison-dialog');
  if (!dialog) return;
  dialog.showModal();
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      dialog.classList.add('is-open');
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var dialog = document.getElementById('membership-comparison-dialog');
  if (!dialog) return;

  function closeDialog() {
    dialog.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      dialog.close();
    }, 350);
  }

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeDialog();
  });

  var closeBtn = dialog.querySelector('.js-mc-dialog-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDialog);
  }

  dialog.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeDialog();
  });

  var desktopMq = window.matchMedia('(min-width: 992px)');
  desktopMq.addEventListener('change', function (e) {
    if (e.matches && dialog.open) {
      dialog.classList.remove('is-open');
      document.body.style.overflow = '';
      dialog.close();
    }
  });
});

// Info modal: one shared dialog, filled from the <template> next to the clicked info icon.
document.addEventListener('DOMContentLoaded', function () {
  var dialog = document.getElementById('mct-info-dialog');
  if (!dialog) return;

  var heading = dialog.querySelector('[data-mct-info-heading]');
  var body = dialog.querySelector('[data-mct-info-body]');
  var sheet = document.getElementById('membership-comparison-dialog');
  var lastTrigger = null;
  var closeTimer = null;

  // Richtext often ends paragraphs with extra Enter presses (<br>) or leaves empty <p>s,
  // which would show up as blank space at the bottom of the modal.
  function trimEmptyLines(root) {
    root.querySelectorAll('.mct-info__text p, .mct-info__text li').forEach(function (block) {
      var last = block.lastChild;
      while (last && (last.nodeName === 'BR' || (last.nodeType === 3 && !last.textContent.trim()))) {
        block.removeChild(last);
        last = block.lastChild;
      }
      if (block.nodeName === 'P' && !block.textContent.replace(/ /g, '').trim() && !block.querySelector('img, iframe, video')) {
        block.remove();
      }
    });
  }

  function openInfo(trigger) {
    var template = trigger.parentElement.querySelector('[data-mct-info-content]');
    if (!template) return;

    var content = template.content.cloneNode(true);
    var title = content.querySelector('.mct-info__title');
    heading.replaceChildren();
    if (title) heading.appendChild(title);
    trimEmptyLines(content);
    body.replaceChildren(content);

    clearTimeout(closeTimer);
    lastTrigger = trigger;
    if (!dialog.open) dialog.showModal();
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
    });
  }

  function closeInfo() {
    if (!dialog.open) return;
    dialog.classList.remove('is-open');
    closeTimer = setTimeout(function () {
      dialog.close();
      // Keep the page locked while the mobile bottom sheet is still open underneath.
      if (!sheet || !sheet.open) document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mct-info]');
    if (!trigger) return;
    e.preventDefault();
    openInfo(trigger);
  });

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeInfo();
  });

  dialog.querySelector('.js-mct-info-close').addEventListener('click', closeInfo);

  dialog.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeInfo();
  });
});
